<h4 class="typo-h4-medium-line-height-20 whitespace-pre-line text-center">
  {{ 'collab_delete_collab_info_alert_title' | translate }}
</h4>

<img src="assets/images/collab-delete-information.png" alt="Collab delete information" class="w-full" />

<h5
  class="typo-h5-book whitespace-pre-line text-center"
  [innerHTML]="'collab_delete_collab_info_alert_subtitle' | translate | markdown | async"
></h5>

<div class="flex w-full justify-center">
  <button class="btn-primary h-10 w-[91px]" (click)="onConfirmDialog()">
    {{ 'collab_delete_collab_info_alert_action_button' | translate }}
  </button>
</div>
